import { ContactEmailRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";

import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CONTACT_EMAIL_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleEmailClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    emailAddress: string
  ) => void
): Column[] => {


  return [
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactEmailRow) => {
        const initials = row.emailAddress.toString().charAt(0).toUpperCase()
        return (
          <TableIcon imageUrl={null} initials={initials} />
        );
      },
    },
    {
      title: "Email",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactEmailRow) => {
        return (
          <div className="">
            <div className="text-md">
              {row.emailAddress}
            </div>

          </div>

        );
      },
    },
    {
      title: "Opis",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactEmailRow) => {
        return (
          <div className="text-sm font-light text-slate-500 truncate">
            {row.description}
          </div>
        );
      },
    },
    {
      title: "Primarna",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactEmailRow) => {
        return (
          <Badge text={row.primary ? "DA" : "NE"} variant={row.primary ? "success" : "danger"} />
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactEmailRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/email.svg"
              onClick={(e) => handleEmailClick(e, row.id)}
            >
              Pošalji email
            </ButtonMenuItem>
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
              Obriši
            </ButtonMenuItem>

          </ButtonMenu>
        );
      },
    },
  ];
};



